import { render, staticRenderFns } from "./PerSources.vue?vue&type=template&id=6d5ca057&"
import script from "./PerSources.vue?vue&type=script&lang=js&"
export * from "./PerSources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports